import * as React from "react";
import { Global, css } from "@emotion/core";
import { ThemeProvider } from "emotion-theming";
import ReactGA from "react-ga";

import { theme } from "./ui/theme";
import { CSSReset } from "@chakra-ui/core";
import Store from "./store/Store";
import Kaart from "./Kaart";
import Grid from "./component/grid/Grid";
const store = new Store();

export const AppContext = React.createContext<Store>(store);

export default function App() {
  React.useEffect(() => {
    ReactGA.initialize("UA-160980193-1");
    ReactGA.pageview("/");

    store.loadData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider value={store}>
        <>
          <Global
            styles={css`
              *,
              *:before,
              *:after {
                box-sizing: border-box;
              }
            `}
          />
          <CSSReset />
          <Grid />
        </>
      </AppContext.Provider>
    </ThemeProvider>
  );
}

export function useStore() {
  const store = React.useContext(AppContext);
  return store;
}
